// J-408 (Louis, 2026-11-02 1:13 PM ET, item 2): Email setup, in the Users & Access area. Admin only, guarded as Users &
// Access is: any other role reads why the page is empty, and the API refuses either way.
import { createFileRoute } from "@tanstack/react-router";

import { AlertBanner } from "@vbltc/ui/components/alert-banner/alert-banner";

import { EmailSetupScreen } from "@/features/aco-admin/components/email-setup-screen";
import { usePermission } from "@/features/auth/use-permission";

export const Route = createFileRoute("/_authenticated/admin/email")({
  staticData: { screenName: "Email setup" },
  component: EmailSetupPage,
});

function EmailSetupPage() {
  const canManage = usePermission({ acoAdmin: ["manageAccess"] });
  if (!canManage)
    return (
      <AlertBanner variant="info" title="Email setup is for the admin role">
        An admin sets the emails sent to users and who they come from.
      </AlertBanner>
    );
  return <EmailSetupScreen />;
}
